import { Button, Modal, TextField, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useAnalytics } from "../firebase/firebase";
import { useEffect, useState } from "react";
import { TiledBackground } from "../theme/background";
import { useTheme } from '@mui/material/styles';

interface EditFolderModalProps {
    open: boolean;
    setOpen: (b: boolean) => void;
    oldName: string;
    submitHandler: (name: string) => void;
}

export const EditFolderModal = (props: EditFolderModalProps) => {
    const { track } = useAnalytics();
    const [newFolderName, setNewFolderName] = useState<string>("");
    const theme = useTheme();

    useEffect(() => {
        setNewFolderName(props.oldName);
    }, [props.open])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
  width: '90vw',                // Responsive width
  maxWidth: 400,                // Don’t exceed your original design
  maxHeight: '90vh',            // Prevent overflow on small screens
        background: theme.bee.barBackground,
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: "scroll",
    };

    return (
        <Modal
            open={props.open}
            onClose={() => props.setOpen(false)}
            aria-labelledby="enter new name"
        >
            <Box sx={style}>
                <TiledBackground offset={0} />
                <Stack direction="column" spacing={3}>
                    <Typography>
                        Folder name
                    </Typography>

                    <TextField
                        value={newFolderName}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setNewFolderName(e.target.value);
                        }}
                        sx={{
                            backgroundColor: "#eee"
                        }} />

                    <Button onClick={() => {
                        if (newFolderName) {
                            props.setOpen(false);
                            props.submitHandler(newFolderName);
                        }
                    }}
                        variant="contained">
                        Rename folder
                    </Button>
                </Stack>
            </Box>
        </Modal >
    )
}